import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData, { GameShortNames } from '../gameData';

export default class PlayerPiece extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, pieceId) {
    super(scene);

    if (pieceId === 'ant') {
      this.pieceDisplay = this.scene.add.sprite(0,0,ABCyaPhaser.Images.DEFAULT_ATLAS, 'idle');
      this.add(this.pieceDisplay);

      this.pieceDisplay.anims.create({
        key: 'walk',
        defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
        frames: [
          { frame: 'walk_0' },
          { frame: 'walk_1' },
          { frame: 'walk_2' },
          { frame: 'walk_3' },
          { frame: 'walk_4' },
          { frame: 'walk_5' },
          { frame: 'walk_6' },
          { frame: 'walk_7' },
          { frame: 'walk_8' },
          { frame: 'walk_9' },
          { frame: 'walk_10' },
          { frame: 'walk_11' },
          { frame: 'walk_12' },
          { frame: 'walk_13' },
          { frame: 'walk_14' },
          { frame: 'walk_15' },
          { frame: 'walk_16' },
          { frame: 'walk_17' },
          { frame: 'walk_18' },
          { frame: 'walk_19' },
          { frame: 'walk_20' },
          { frame: 'walk_21' },
          { frame: 'walk_22' },
          { frame: 'walk_23' },
        ],
        repeat: -1
      });

      this.pieceDisplay.x = -(this.pieceDisplay.width / 2);
      this.pieceDisplay.y = -(this.pieceDisplay.height / 2);
    }
    else {
      this.pieceDisplay = ABCyaPhaser.Images.addImage(0,0,`player-piece-${pieceId}`, this);
    }

    this.isMoving = false;

    ABCyaPhaser.Container.setContainerInteractive(this, false);
  }

  tick () {
    if (gameData.game !== GameShortNames.fg && gameData.game !== GameShortNames.fgJr) return;

    if (this.isMoving) {
      if (!this.pieceDisplay.anims.isPlaying) {
        this.pieceDisplay.play('walk', false);
      }
    }
    else if (this.pieceDisplay.anims.isPlaying) {
      this.pieceDisplay.stop().setFrame('idle');
    }
  }
}